angular.module('ihestiaIkomunikator.fullListPanel')
  .controller('ikomunikatorGridFilterCtrl', ['$scope', 'iKomunikatorConstants',
    function($scope, iKomunikatorConstants) {
      $scope.constants = iKomunikatorConstants;
    }
  ]);